import React, { useEffect, useState, useCallback, useContext } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { AppContext } from "../../context/appContext";

const QUOTE_REQUEST_LIST_URL =
	"https://i4ljrfxm3i.execute-api.us-east-1.amazonaws.com/v1/quoteRequestForBaker";

const BakerQuoteRequestList = () => {
  const navigate = useNavigate();
  const { setGlobalLoading, userSub } = useContext(AppContext);

  const [quoteRequestList, setQuoteRequestList] = useState([]);

  const fetchQuoteRequestList = useCallback(async () => {
    if (!userSub) {
      return;
    }

    try {
      setGlobalLoading(true);
      const response = await axios.get(`${QUOTE_REQUEST_LIST_URL}?userSub=${userSub}`);

      if (
        response.data?.data &&
        Array.isArray(response.data?.data) &&
        response.data?.data?.length > 0
      ) {
        setQuoteRequestList(response.data?.data);
        setGlobalLoading(false);
      }
      setGlobalLoading(false);
    } catch (error) {
      console.error("❌ Error fetching bakeries:", error);
    }
  }, [setGlobalLoading, userSub]);

  useEffect(() => {
    fetchQuoteRequestList();
  }, [fetchQuoteRequestList]);

  const navigateToQuoteRequestDetailPage = ({ id, bakery }) => {
    navigate(`/b/quote-request/${id}/${bakery}`);
  };

  return (
    <Container
      className="py-5"
      style={{ position: "relative" }}>
      <Row className="mb-4">
        <Col className="text-center">
          <h3>My Quote Requests:</h3>
        </Col>
      </Row>
      {quoteRequestList?.length > 0 && (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th
                style={{ width: "150px", backgroundColor: "#2d5986", color: "#fff" }}>
                Link
              </th>
              <th
                style={{ width: "150px", backgroundColor: "#2d5986", color: "#fff" }}>
                Ref Code
              </th>
              <th
                style={{ width: "150px", backgroundColor: "#2d5986", color: "#fff" }}>
                Date
              </th>
              <th
                style={{ width: "150px", backgroundColor: "#2d5986", color: "#fff" }}>
                Customer
              </th>
              <th
                style={{ width: "150px", backgroundColor: "#2d5986", color: "#fff" }}>
                Product
              </th>
              <th
                style={{ width: "150px", backgroundColor: "#2d5986", color: "#fff" }}>
                Price
              </th>
              <th
                style={{ width: "150px", backgroundColor: "#2d5986", color: "#fff" }}>
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            {quoteRequestList?.map((q, i) => {
              return (
                <tr key={i.toString()}>
                  <td>
                    <span
                      style={{
                        textDecoration: "underline",
                        color: "#0033cc",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        navigateToQuoteRequestDetailPage({
                          id: q.id,
                          bakery: q.urlPathName
                        })
                      }>
                      Link to Quote
                    </span>
                  </td>
                  <td>{q.refCode}</td>
                  <td>{moment(q.createdAt).format("M/DD")}</td>
                  <td>{q.customer}</td>
                  <td>Cake</td>
                  <td>{q.bakerPrice ? `$${q.bakerPrice}` : "N/A"}</td>
                  <td
                    style={{
                      backgroundColor: !q.bakerStatus
                        ? "transparent"
                        : q.bakerStatus === "Waiting on Customer to Confirm"
                        ? "#b3ffb3"
                        : q.bakerStatus === "Waiting on Customer to Respond"
                        ? "#b3ffb3"
                        : q.bakerStatus === "Customer Paid"
                        ? "#00cc00"
                        : "#fea2c2",
                    }}>
                    {q.bakerStatus}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      )}
    </Container>
  );
};

export default BakerQuoteRequestList;
